const deployEnv = require('@ebay/environment-ebay');

// get the value of the env set by the deploy scripts
/**
 * environment-ebay can be called only on server rendered components
 * When component is called from client side, the process.env in deployEnv is not available
 * Relying on window for client side component load in catch block
 * The url path for micro-frame or ajax call are determined by the env variable set
 * For testing the app that includes our component in local environment or FP,
 * the component will load the qa path so that data is available.
 * All other environments load relative path.
 */
const STOREFRONT_PAGE_ID = '3418065';
const STRMGTWEB_PAGE_ID = '3558328';
const STORESOCIAL_PAGE_ID = '4256139';

const getEnvFromWindow = () => {
    if (typeof window !== 'undefined') {
        const path = window.location.host;
        if (path.indexOf('paradise.qa.ebay.com') === -1 &&
            (path.indexOf('qa.ebay.com') > -1 || path.indexOf('localhost') > -1)) {
            return 'development';
        }
        return 'production';
    }
    return null;
};

const getEnvFromDeployEnv = () => {
    try {
        if (deployEnv.isDev()) {
            return 'development';
        } else if (deployEnv.isStage()) {
            return 'staging';
        } else if (deployEnv.isPreProd()) {
            return 'pre-production';
        }
    } catch (err) {
        return 'production';
    }
    return 'production';
};

const getEnv = () => {
    const envVal = getEnvFromWindow();
    if (envVal) return envVal;

    return getEnvFromDeployEnv();
};

/**
 * @param {*} env - deployed env
 * @returns hostname - when running locally, QA url is used otherwise relative url is used
 * you can choose to change it to return blank string, if the endpoint is supported by the nodejs of the same app
 */
const getHostname = (env) => env === 'development' || env === 'test'
    ? 'https://www.qa.ebay.com'
    : '';

/**
 * @param {string} env - deployed environment
 * @param {string} pageId
 * @returns {string} basepath for the announce endpoint
 */
const getAnnouncementsBasePath = (env, pageId) => {
    const hostname = getHostname(env);
    const map = {
        [STOREFRONT_PAGE_ID]: '/sh/str/edit/announcement',
        [STRMGTWEB_PAGE_ID]: '/sh/str/edit/announcement',
        [STORESOCIAL_PAGE_ID]: '/sh/str/social/announcement'
    };
    return hostname + map[pageId];
};

/**
 * @param {string} env - deployed environment
 * @param {string} pageId
 * @returns {string} basepath for the announce prefs
 */
const getUserPrefsBasePath = (env, pageId) => {
    const hostname = getHostname(env);
    const map = {
        [STOREFRONT_PAGE_ID]: '/sh/str/edit/announcement_prefs',
        [STRMGTWEB_PAGE_ID]: '/sh/str/edit/announcement_prefs',
        [STORESOCIAL_PAGE_ID]: '/sh/str/social/announcement_prefs'
    };
    return hostname + map[pageId];
};

/**
 * @param {string} env - deployed environment
 * @returns {string} basepath for the social-share-template endpoint
 */
const getSocialShareBasePath = (env) => env === 'development' || env === 'test'
    ? 'https://www.qa.ebay.com/str/svc/social-share-template/'
    : '/str/svc/social-share-template/';

const getGenericShareTemplatePath = (env) => env === 'development' || env === 'test'
    ? 'https://www.qa.ebay.com/str/svc/generic-share-template/'
    : '/str/svc/generic-share-template/';

module.exports = {
    getEnv,
    getEnvFromWindow,
    getEnvFromDeployEnv,
    getAnnouncementsBasePath,
    getUserPrefsBasePath,
    getSocialShareBasePath,
    getGenericShareTemplatePath
};
